import { getEnv, Instance, SnapshotOut, types } from "mobx-state-tree"
import { SettingsInfoData, Event, WalletSwitchData, OrderProposalData } from "~proto"
import config from "~config/env"
const ws_arr = config.WS_URL.split(",")
const defaultWs = ws_arr[0]
/** ENCRYPTION_KEY
 * ConfigStore 用于存储一些系统配置
 */
export const ConfigStoreModel = types
  .model("ConfigStore")
  .props({
    ws_arr: types.optional(types.array(types.string), ws_arr),
    ws: types.optional(types.string, defaultWs),
    api: types.optional(types.string, config.API_URL),
    cdn: types.optional(types.string, config.CDN_URL),
    appName: types.optional(types.string, config.APP_NAME),
    redirectURL: types.optional(types.string, config.REDIRECT_URL),
    encrypt_key: types.optional(types.string, config.ENCRYPT_KEY),
    /** 与 env.js 中 ENV_NAME 对齐，用于检测切换环境后清理持久化的旧 API */
    buildEnv: types.optional(types.string, config.ENV_NAME),
    order_proposal_min: types.maybeNull(types.optional(types.number, 0)),
    order_proposal_max: types.maybeNull(types.optional(types.number, 0)),
    wallet_on: types.optional(types.boolean, false),
    order_proposal_on: types.optional(types.boolean, false),
  })
  .views((self) => ({
    get upload_url() {
      return self.api + "/upload/file"
    },
  }))
  .actions((self) => ({
    setWS(ws: string) {
      self.ws = ws
    },
    setAPI(url: string) {
      self.api = url
      const { api } = getEnv(self)
      api.config.update({ url })
    },
    setCDN(url: string) {
      self.cdn = url
    },
    applyEnvDefaults() {
      self.api = config.API_URL
      self.cdn = config.CDN_URL
      self.ws = defaultWs
      self.ws_arr.clear()
      ws_arr.forEach((url) => self.ws_arr.push(url))
      self.appName = config.APP_NAME
      self.redirectURL = config.REDIRECT_URL
      self.encrypt_key = config.ENCRYPT_KEY
      self.buildEnv = config.ENV_NAME
    },
    update(data: Partial<ConfigStore>) {
      Object.keys(data).forEach((key) => {
        self[key] = data[key]
      })
    },
    onSettingInfo({ data }: Event<SettingsInfoData>) {
      self.order_proposal_min = Number(data.order_proposal_min)
      self.order_proposal_max = Number(data.order_proposal_max)
      self.wallet_on = data.wallet_on
      self.order_proposal_on = data.order_proposal_on
    },
    onWalletSwitched({ data }: Event<WalletSwitchData>) {
      self.wallet_on = data.active
    },
    onOrderProposalChanged({ data }: Event<OrderProposalData>) {
      self.order_proposal_min = Number(data.order_proposal_min)
      self.order_proposal_max = Number(data.order_proposal_max)
      self.order_proposal_on = data.order_proposal_on
    },
  }))

type ConfigStoreType = Instance<typeof ConfigStoreModel>
export interface ConfigStore extends ConfigStoreType {}
type ConfigStoreSnapshotType = SnapshotOut<typeof ConfigStoreModel>
export interface ConfigStoreSnapshot extends ConfigStoreSnapshotType {}
export const createConfigStoreDefaultModel = () => types.optional(ConfigStoreModel, {})
